"use strict";

exports.__esModule = true;
exports.default = void 0;

var _universalEnv = require("universal-env");

var _aliMiniapp = _interopRequireDefault(require("./ali-miniapp"));

var _wechatMiniprogram = _interopRequireDefault(require("./wechat-miniprogram"));

var _web = _interopRequireDefault(require("./web"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-extraneous-dependencies
var createContext;

if (_universalEnv.isMiniApp && !_universalEnv.isWeb) {
  // For cased that import wechat or miniapp sdk in web
  createContext = _aliMiniapp.default;
} else if (_universalEnv.isWeChatMiniProgram && !_universalEnv.isWeb) {
  createContext = _wechatMiniprogram.default;
} else {
  // Web as default
  createContext = _web.default;
}

var _default = createContext;
exports.default = _default;